module.exports = __webpack_public_path__ + "img/presale-detail13.c6a1d452.png";